import { toast } from 'sonner';
import { useDeleteExperience } from '@/features/experiences/hooks/useDeleteExperience';
import { useUpdateExperienceStatus } from '@/features/experiences/hooks/useUpdateExperienceStatus';
import type { ExperienceStatus } from '@/features/experiences/types/experience.types';

export interface CandidateExperienceActions {
  handleDelete: (experienceId: string) => void;
  handleStatusChange: (experienceId: string, status: ExperienceStatus) => void;
}

export function useCandidateExperienceActions(candidateId: string): CandidateExperienceActions {
  const { deleteExperience } = useDeleteExperience();
  const { updateExperienceStatus: updateStatus } = useUpdateExperienceStatus();

  const handleDelete = (experienceId: string): void => {
    deleteExperience(
      { candidateId, experienceId },
      {
        onSuccess: () => toast.success('Experience deleted successfully'),
        onError: () => toast.error('Failed to delete experience'),
      }
    );
  };

  const handleStatusChange = (experienceId: string, status: ExperienceStatus): void => {
    updateStatus(
      { candidateId, experienceId, request: { status } },
      {
        onSuccess: () => toast.success('Experience status updated'),
        onError: () => toast.error('Failed to update status'),
      }
    );
  };

  return { handleDelete, handleStatusChange };
}
